export default {
  recommends: 'Reverb Recommends',
  topPick: 'Top Pick',
  reverbNews: 'Reverb News',
  treatYourself: 'Treat Yourself',
  seeSimilar: 'See Similar {{category}}',
  seeMore: 'See More',
  addToCart: 'Add to Cart',
};
